import React, {
  useEffect,
} from 'react';
import {
  useHistory,
} from 'react-router';
import {
  useObserver,
} from 'mobx-react';
import {
  RequestStatus,
  stores,
} from '../../mobx-store';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeliveryRegionDTO,
} from './DTOs/deliveryRegionDTO';

const DeliveryRegionsTableScreen: React.FC = () => {
  const history = useHistory();

  useEffect(() => {
    (async function () {
      await stores.deliveryRegionStore.getDeliveryRegionsList();
    }());
  }, []);

  const tableHeaders = [
    {
      title: 'ID',
    },
    {
      title: 'Name',
    },
    {
      title: 'Delivery Period',
    },
    {
      title: 'Status',
    },
  ];

  const handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const currentRegion = stores.deliveryRegionStore.deliveryRegionsList.find((a, i) => i === index)!;

    const updatedStatusRegion: DeliveryRegionDTO = {
      ...currentRegion,
      isActive: value,
    };

    stores.deliveryRegionStore.updateDeliveryRegionById(currentRegion.regionId, updatedStatusRegion, index)
      .then(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
        }), 8000, 'success');
      })
      .catch(() => {
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 8000, 'error');
      });
  };

  const handleEditButtonClicked = (index: number) => {
    history.push(`/delivery-regions/${stores.deliveryRegionStore.deliveryRegionsList[index].regionId}/edit`);
  };

  const cellTypes: TableCellTypes[] = [
    {
      cellType: 'Text',
      key: 'regionId',
    },
    {
      cellType: 'Text',
      key: 'regionName',
    },
    {
      cellType: 'Text',
      key: 'daysTillDelivery',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('FormActiveLabel', {
      }),
      inactiveLabel: translate('FormNotActiveLabel', {
      }),
      onChange: handleTableToggleCellChange,
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: handleEditButtonClicked,
    },
  ];

  const getTableData = () => stores.deliveryRegionStore.deliveryRegionsList.map(
    (deliveryRegion: DeliveryRegionDTO) => ({
      regionId: deliveryRegion.regionId,
      regionName: deliveryRegion.regionName,
      daysTillDelivery: deliveryRegion.daysTillDelivery,
      isActive: deliveryRegion.isActive,
      edit: translate('editButton', {
      }),
    }),
  );

  const createAddButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: (): void => {
      history.push('/delivery-regions/new');
    },
  });

  return useObserver(
    () => (
      <GeneralTableComponent
        title={translate('deliveryRegionsTableTitle', {
        })}
        emptyMessage={translate('deliveryRegionsEmptyTableMessage', {
        })}
        tableHeader={tableHeaders}
        tableData={getTableData()}
        tableCellTypes={cellTypes}
        addButton={createAddButton()}
        loading={stores.deliveryRegionStore.getDeliveryRegionsListRequestStatus === RequestStatus.LOADING}
        loadingStatus={[
          stores.deliveryRegionStore.getDeliveryRegionsListRequestStatus,
        ]}
      />
    ),
  );
};

export default DeliveryRegionsTableScreen;
